import { lazySentryCaptureException } from "@app/helpers/sentry-capture";
import { getDSCLThemeFromWhitelabel } from "@app/helpers/theme";

let theme_loader_promise: Promise<void> | null = null;

/**
 * Imports the partner DSCL theme for the application.
 * Awaiting this function is required before hydration to avoid flickering and hydration errors.
 * This can be removed after the DSCL migration to Horizon is complete.
 * see: https://github.com/busbud/public-website/issues/24745
 */
export async function setupWhitelabelTheme(): Promise<void> {
  if (theme_loader_promise) {
    return theme_loader_promise;
  }

  if (
    !window ||
    !window.BB ||
    !window.BB.whitelabel_context ||
    window.BB.whitelabel_theme !== undefined
  ) {
    return;
  }

  theme_loader_promise = getDSCLThemeFromWhitelabel(
    window.BB.whitelabel_context?.whitelabel?.name
  )
    .then(theme => {
      window.BB.whitelabel_theme = theme;
    })
    .catch(err => {
      lazySentryCaptureException(err);
      window.BB.whitelabel_theme = undefined;
    });
}
